"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sorisole": {
    "5511040c": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "skipSearch": false
    }],
    "botta-bassa": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "978cc5cc": [{
      "hkey": "66d0133b",
      "slug": "valli",
      "name": "Valli",
      "primary": true,
      "skipSearch": false
    }],
    "canvarola-valli": [{
      "hkey": "66d0133b",
      "slug": "valli",
      "name": "Valli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4678eea4": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "skipSearch": false
    }],
    "castel-de-pilis": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e82d90e": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "skipSearch": false
    }],
    "grumel-mez": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0263af25": [{
      "hkey": "528f8d37",
      "slug": "lacsolo",
      "name": "Lacsolo",
      "primary": true,
      "skipSearch": false
    }],
    "laxolo": [{
      "hkey": "528f8d37",
      "slug": "lacsolo",
      "name": "Lacsolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7b8b251f": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-dei-campi": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "777bb689": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "skipSearch": false
    }],
    "rigla": [{
      "hkey": "979cc978",
      "slug": "sorisole",
      "name": "Sorisole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;